import { BaseModel, attr} from "../../lib/itn-ui-kit/data";

export default class LawfirmModel extends BaseModel {
    @attr('string') name;
    @attr('string') phone;
}